import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import { useRouter } from 'next/router';
import { Table, Tag, Space } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import moment from 'moment';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { collection, getDocs } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));
export default function SoldNfts(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const classes = useStyles();
  const router = useRouter();
  const [nftsList, setnftsList] = useState([]);
  const [loadingNfts, setloadingNfts] = useState(false);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'tokenName',
      key: 'tokenName',
      width: 250,
      render: (text, listObj) => {
        const url = `${window.location.origin}/nft/${listObj.tokenId}`;
        return (
          <span
            className="link link-color"
            onClick={() => {
              window.open(url);
            }}
            style={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            <a
              href={url}
              onClick={(event) => {
                event.preventDefault();
              }}
            >
              {text}
            </a>
          </span>
        );
      },
    },
    {
      title: 'Thumbnail',
      dataIndex: 'icons',
      render: (text) => (
        <div className="flex ">
          <img
            className="object-contain border-box-color border"
            style={{ width: 60, height: 40 }}
            src={text && text[0] ? text[0] : ''}
            alt="Thumbnail"
          />
        </div>
      ),
    },
    {
      title: 'Transaction',
      dataIndex: 'tokenId',
      key: 'issueTxid',
      render: (text, listObj) => {
        const txId = listObj?.txid
          ? listObj.txid
          : listObj?.issueTxid
          ? listObj.issueTxid
          : listObj.tokenId;

        const url = listObj?.txid
          ? `https://whatsonchain.com/tx/${listObj.txid}`
          : listObj?.issueTxid
          ? `https://whatsonchain.com/tx/${listObj.issueTxid}`
          : `${window.location.origin}/nft/${listObj.tokenId}`;
        return (
          <Tooltip title={txId} classes={classes}>
            <span
              className="link link-color"
              onClick={() => window.open(url)}
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              <a
                href={url}
                onClick={(event) => {
                  event.preventDefault();
                }}
              >
                {txId.substring(0, 20) + '...'}
              </a>
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: 'Selling price',
      dataIndex: 'price',
      key: 'price',
      render: (text, listObj) => (
        <span>
          ${' '}
          {(() => {
            if (listObj && listObj.isMultiple) {
              if (listObj.nftSaleType === 'SalePrice') {
                return text;
              } else {
                return listObj.minBiddingPrice;
              }
            } else {
              if (listObj.nftSaleType === 'SalePrice') {
                return text;
              } else {
                return listObj.minBiddingPrice;
              }
            }
          })()}
        </span>
      ),
    },
    {
      title: 'Number',
      dataIndex: 'nftQuantity',
      key: 'nftQuantity',
      render: (text, listObj) => {
        return (
          <span>
            No {listObj?.isMultiple && listObj?.index ? listObj.index : 1}/
            {listObj?.nftQuantity ? parseInt(listObj?.nftQuantity) : 1}
          </span>
        );
      },
    },
    {
      title: 'Category',
      key: 'category',
      dataIndex: 'category',
      render: (text) => (
        <Tag color="#40a9ff">{text ? text.toUpperCase() : '-'}</Tag>
      ),
    },
    {
      title: 'Selling date',
      dataIndex: 'soldData',
      key: 'soldData',
      width: 200,
      render: (text) => (
        <span>
          {text ? moment(Number(text)).format('LT - D MMM, YYYY') : '-'}
        </span>
      ),
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.soldData - b.soldData,
    },
  ];

  useEffect(() => {
    if (userDataRedux) {
      getSoldNftsList();
    }
  }, [userDataRedux]);

  const getSoldNftsList = async () => {
    setloadingNfts(true);
    let dataRef = await getDocs(
      collection(
        firebaseFireStore,
        'musicartUserData',
        userDataRedux.uid,
        'soldNfts',
      ),
    );

    if (dataRef.empty) {
      setnftsList([]);
      setloadingNfts(false);
      return;
    }

    let dataArr = [];
    dataRef.forEach((doc) => {
      dataArr.push(doc.data());
    });

    setnftsList(dataArr);
    setloadingNfts(false);
  };

  return (
    <div>
      <div className="nft-card-con">
        {!loadingNfts && nftsList.length > 0 && (
          <div className="w-full">
            <Table pagination={false} columns={columns} dataSource={nftsList} />
          </div>
        )}
        {loadingNfts && (
          <div
            className="flex 	w-full  mx-6 my-6"
            style={{ flexDirection: 'column' }}
          >
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={20} width="60%" />
          </div>
        )}
        {!loadingNfts && nftsList.length === 0 && (
          <div className="text-center w-full text-blueGray-500">
            <p className="text-center">0 NFTs found</p>
          </div>
        )}
      </div>
    </div>
  );
}
